import React from 'react'
import {Link} from 'react-router-dom'

function PlayerSmallCard({name,imgPlayer,imgTeam,id}) {
  return (
    <div className='w-full min-h-[80px] flex max-h-[50px] border  border-gray-400 rounded-lg p-4 '>

      <div className=' basis-1/4 flex justify-start items-center '>
      <img className='h-[70px] ' src={imgPlayer}/>
      </div>

      <Link to={`/players/card/${id}`}  className='basis-2/4 flex flex-col flex justify-center items-center text-xs font-extrabold'>
        {name}
      </Link>


      <div className=' basis-1/4 flex justify-start items-center '>
      <img className='h-[70px] ' src={imgTeam}/>
      </div>

    </div>
  )
}

export default PlayerSmallCard
